import React,{ useState} from 'react';
import { Grid } from '@mui/material';
import Icon from 'components/icons/icon'
import { styled } from '@mui/material/styles';

const ContainerGrid = styled(Grid)`
        display: flex;
        flex-direction: column;
        padding: 15px;
        justify-content: space-around;
        align-items: center;
        text-align: center;
        background-color: white;
        border-radius: 15px;
        color:var(--pxft-darkgrey);
        filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.17));
        transition: 0.2s linear;

        &:hover {
            color:white;
            background-color: var(--pxft-primary);
        },

        & .icon {
            padding: 10px 0;
        }
        & .content {
            display: flex;
            flex-direction: column;
            width: 80%;
        }
        & .content h5{
            padding: 0 0 10px 0;
        }
`;

const IconCardB = ({IconCard})=> {
        const [isHover,setIsHover] = useState(false);
        const mouseEnter = () =>{
            setIsHover(true);
        }
        const mouseOut = () =>{
            setIsHover(false);
        }


        return (
            <ContainerGrid item xs={6} md={3} sx={{m:2}} width={250} minHeight={IconCard.height} display='flex' flexDirection='column' onMouseEnter={() => mouseEnter()} onMouseLeave={() => mouseOut()}>
                    <div className='icon'>
                        <Icon icon={IconCard.icon} width={IconCard.iconWidth} height={IconCard.iconHeight} fill={isHover? 'white':'var(--pxft-primary)'}/>
                    </div>
                    <div className='content'>
                        <h5>{IconCard.title}</h5>
                        <p>{IconCard.contents}</p>
                    </div>
            </ContainerGrid>
        );
}

export default IconCardB;